import React, { useState, useEffect, useMemo } from 'react';
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
// WelcomeKPI removed - functionality merged into ActiveCustomerList
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../../firebase';
import ActiveCustomerList from './ActiveCustomerList';
import EventFeed from './EventFeed';
import RecentClientActivity from './RecentClientActivity';

interface User {
  firstName?: string;
  name?: string;
  displayName?: string;
  email?: string;
  id?: string;
  uid?: string;
}

const DashboardPage = () => {
  const [user, setUser] = useState<User | null>(null);
  const [jobCount, setJobCount] = useState<number>(0);
  const [overdueJobCount, setOverdueJobCount] = useState<number>(0);

  useEffect(() => {
    const fetchJobs = async () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const nextWeek = new Date();
      nextWeek.setDate(today.getDate() + 7);
      nextWeek.setHours(23, 59, 59, 999);
  
      const jobsSnapshot = await getDocs(collection(db, 'jobs'));
      const jobsDueNextWeek = jobsSnapshot.docs.filter(doc => {
        const job = doc.data();
        const dueDate = new Date(job.dueDate);
        return dueDate >= today && dueDate <= nextWeek;
      });
  
      const overdueJobs = jobsSnapshot.docs.filter(doc => {
        const job = doc.data();
        const dueDate = new Date(job.dueDate);
        return dueDate < today && (job.status === 'Open' || job.status === 'Pending');
      });
  
      setJobCount(jobsDueNextWeek.length);
      setOverdueJobCount(overdueJobs.length);
    };
  
    fetchJobs();
  }, []);

  useEffect(() => {
    try {
      const userData = localStorage.getItem('user');
      if (userData) {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);
      }
    } catch {}
  }, []);

  const derivedFirstName = useMemo(() => {
    const any = (obj: any, keys: string[]): string | undefined => {
      for (const k of keys) {
        const v = obj?.[k];
        if (typeof v === 'string' && v.trim()) return v.trim();
      }
      return undefined;
    };
    const fromUser = any(user || {}, [
      'firstName','firstname','first_name','givenName','given_name',
      'name','displayName','display_name','fullName','full_name'
    ]);
    if (fromUser) return fromUser.split(/\s+/)[0];

    const fromLocal = any({
      display_name: localStorage.getItem('display_name') || '',
      email: localStorage.getItem('email') || ''
    }, ['display_name']);
    if (fromLocal) return fromLocal.split(/\s+/)[0];

    const email = (user as any)?.email || localStorage.getItem('email') || '';
    if (email) {
      const local = email.split('@')[0];
      if (local) return local;
    }
    return '';
  }, [user]);

  return (
    <>
      {/* Active Customers - Job/Email Hub */}
      <div className='row g-5 g-xl-8 mb-5 mb-xl-8'>
        <div className='col-12'>
          <div className='card card-xl-stretch'>
            <ActiveCustomerList />
          </div>
        </div>
      </div>

      <div className='row g-5 g-xl-8'>
        <div className='col-xl-6'>
          <div className='card card-xl-stretch mb-5 mb-xl-8'>
            <RecentClientActivity />
          </div>
        </div>
        <div className='col-xl-6'>
          <div className='card card-xl-stretch mb-5 mb-xl-8'>
            <EventFeed />
          </div>
        </div>
      </div>
    </>
  );
};

const UserDashboard = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'MENU.DASHBOARD'})}
      </PageTitle>
      <DashboardPage />
    </>
  );
};

export {UserDashboard}